<script lang="ts" setup></script>
<template>
  <div
    class="flex justify-center items-center rounded-2xl bg-neutral-100 dark:bg-neutral-700 px-4 py-3 gap-2"
  >
    <span class="circle size-3.5 bg-neutral-400 rounded-full bouncing"></span>
    <span class="circle size-3.5 bg-neutral-400 rounded-full bouncing"></span>
    <span class="circle size-3.5 bg-neutral-400 rounded-full bouncing"></span>
  </div>
</template>
<style scoped>
.circle.scaling {
  animation: typing 1000ms ease-in-out infinite;
  animation-delay: 3600ms;
}

.circle.bouncing {
  animation: bounce 1000ms ease-in-out infinite;
  animation-delay: 3600ms;
}

.circle:nth-child(1) {
  animation-delay: 0ms;
}

.circle:nth-child(2) {
  animation-delay: 333ms;
}

.circle:nth-child(3) {
  animation-delay: 666ms;
}

@keyframes typing {
  0% {
    transform: scale(1);
  }
  33% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  33% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
